import { create } from "zustand";

import type {
    EmailListSendProcedureItem,
    EmailListSendResourceItem,
} from "@/models";

type EmailItemTypeEnum = "procedure" | "link" | "attachment";

export type ProcedureMetadata = {
    kind: "procedure";
    feedName: string;
    language1Name: string;
    language2Name?: string;
    printOptionName?: string;
};

export type ResourceMetadata = {
    kind: "resource";
    collectionName?: string;
    resourceType: "link" | "attachment";
};

export type EmailItem = {
    id: string;
    title: string;
    type: EmailItemTypeEnum;
    payload: EmailListSendProcedureItem | EmailListSendResourceItem;
    metadata?: ProcedureMetadata | ResourceMetadata;
};

interface EmailListState {
    items: EmailItem[];
    add: (item: EmailItem) => void;
    remove: (id: string) => void;
    clear: () => void;
}

export const useEmailListStore = create<EmailListState>((set, get) => ({
    items: [],
    add: (item) =>
        set(() => {
            const existing = get().items.filter((i) => i.id !== item.id);
            return { items: [...existing, item] };
        }),
    remove: (id) => set({ items: get().items.filter((i) => i.id !== id) }),
    clear: () => set({ items: [] }),
}));
